import React, { useState } from 'react';
import { Form, Input, Button, Typography, Alert } from 'antd';
import { Link } from 'react-router-dom';
import { authApi } from '../../services/portalApi';
import AuthCard from '../../components/AuthCard';
import zeroLogo from '../../assets/images/zero-logo-small.png';

export default function ForgotPassword() {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const onFinish = async ({ email }) => {
    setLoading(true);
    try {
      await authApi.forgotPassword(email);
      setSent(true);
    } catch (_) {
      setSent(true); // never reveal whether the account exists
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard foot={<Link to="/login">Back to sign in</Link>}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img src={zeroLogo} alt="Agent Zero" style={{ width: 44, height: 44, objectFit: 'contain' }} />
        <Typography.Title level={4} style={{ marginTop: 12, marginBottom: 0 }}>
          Reset your password
        </Typography.Title>
      </div>
      {sent ? (
        <Alert
          type="success"
          showIcon
          message="Check your email"
          description="If that account exists, we've sent a link to reset your password. It expires in 1 hour."
        />
      ) : (
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
            <Input size="large" placeholder="you@company.com" autoComplete="username" />
          </Form.Item>
          <Button type="primary" htmlType="submit" size="large" block loading={loading}>
            Send reset link
          </Button>
        </Form>
      )}
    </AuthCard>
  );
}
